import s from "./Avatar.module.scss";

const initials = (name: string) => name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() ?? "").join("");

/** Decorative: the name is always written next to it. `initials` when the server already gives them. */
export const Avatar = ({ name, initials: given, size = "md" }: { name: string; initials?: string; size?: "sm" | "md" | "lg" }) => (
  <span aria-hidden="true" className={`${s.avatar} ${s[size]}`}>{given?.trim() || initials(name)}</span>
);
